import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  ChannelChangeAction,
  ChannelChangeMutation,
  ChannelChangeState,
  ChannelDirection
} from "@/components/channelChange/types";
import apiStorageInterface from "@/services/apiStorageInterface";

const updateChannelNumber = (
  context: ActionContext<ChannelChangeState, RootState>,
  digit?: number
): void => {
  if (!digit) {
    context.commit(ChannelChangeMutation.ClearChannelNumber);
    return;
  }
  if (context.state.channelNumber.length < 3) {
    context.commit(ChannelChangeMutation.SetChannelNumber, digit);
    context.commit(ChannelChangeMutation.SetChannelChange, true);
  }
};

const updateChannelChange = (
  context: ActionContext<ChannelChangeState, RootState>,
  status: boolean
): void => {
  context.commit(ChannelChangeMutation.SetChannelChange, status);
};

const updateSource = (
  context: ActionContext<ChannelChangeState, RootState>,
  source: string
): void => {
  if (source !== context.state.source) {
    context.commit(ChannelChangeMutation.SetSource, source);
  }
};

const updateOffset = (
  context: ActionContext<ChannelChangeState, RootState>,
  offset: number
): void => {
  context.commit(ChannelChangeMutation.SetOffset, Math.max(0, offset));
};

const updateChannel = async (
  context: ActionContext<ChannelChangeState, RootState>,
  direction: ChannelDirection
): Promise<void> => {
  /*maybe there is a better way but for now I find the current channel via source
    since it is unique and then after checking if there is anything
    before or after in the array switch to that channel
   */
  await apiStorageInterface.fetchCustomChannelList().then((channels) => {
    //for loops are much less taxing then forEach and for a 5y/o TV it is a noticeable difference
    for (let i = 0; i < channels.length; i++) {
      if (channels[i].videoLive === context.state.source) {
        switch (direction) {
          case ChannelDirection.ChannelUp:
            if (i > 0) {
              context.commit(
                ChannelChangeMutation.SetSource,
                channels[i - 1].videoLive
              );
              context.commit(ChannelChangeMutation.SetOffset, 0);
            }
            break;
          case ChannelDirection.ChannelDown:
            if (i < channels.length - 1) {
              context.commit(
                ChannelChangeMutation.SetSource,
                channels[i + 1].videoLive
              );
              context.commit(ChannelChangeMutation.SetOffset, 0);
            }
            break;
        }
        return;
      }
    }
  });
};

export const actions: ActionTree<ChannelChangeState, RootState> &
  Record<ChannelChangeAction, Action<ChannelChangeState, RootState>> = {
  [ChannelChangeAction.UpdateChannelNumber]: updateChannelNumber,
  [ChannelChangeAction.UpdateChannelChange]: updateChannelChange,
  [ChannelChangeAction.UpdateSource]: updateSource,
  [ChannelChangeAction.UpdateOffset]: updateOffset,
  [ChannelChangeAction.UpdateChannel]: updateChannel
};
